import { createFileRoute } from "@tanstack/react-router";
import CatalogCardPage from "@/site/pages/catalog-card";

/** Category context (old `ccid`) the card was opened from — drives breadcrumb + suggestions. */
type CardViewSearch = { ccid?: string };

export const Route = createFileRoute("/card/view/$cardId")({
  component: CatalogCardPage,
  validateSearch: (search: Record<string, unknown>): CardViewSearch => ({
    ccid: typeof search.ccid === "string" && search.ccid ? search.ccid : undefined,
  }),
});
